import axios from "axios";

const api = axios.create({
  baseURL: "https://servicodados.ibge.gov.br/api/v1/localidades",
});

export const ibgeApi = {
  getEstados: async () => {
    const { data } = await api.get("/estados?orderBy=nome");
    return data;
  },
  getCidades: async (uf) => {
    const { data } = await api.get(`/estados/${uf}/municipios?orderBy=nome`);
    return data;
  },
};
